import { useQuery } from "@tanstack/react-query";
import {
  downloadAdditionalServiceFiles,
  getAdditionalService,
  getAdditionalServices,
  getPromotedAdditionalServices,
} from "@services/additional-services/services";
import {
  type IAdditionalService,
  type IDetailedAdditionalService,
} from "@services/additional-services/types";

export const useAdditionalServicesQuery = () =>
  useQuery<IAdditionalService[]>({
    queryKey: ["additionalServices"],
    queryFn: getAdditionalServices,
  });

export const useAdditionalServiceQuery = (
  serviceId: IAdditionalService["additionalServiceId"],
) =>
  useQuery<IDetailedAdditionalService>({
    queryKey: ["additionalService", serviceId],
    queryFn: () => getAdditionalService(serviceId),
  });

export const usePromotedAdditionalServicesQuery = () =>
  useQuery<IAdditionalService[]>({
    queryKey: ["additionalServicesPromoted"],
    queryFn: getPromotedAdditionalServices,
    staleTime: Infinity,
  });

export const useAdditionalServiceFilesQuery = (
  serviceProviderId: number,
  jointBillServiceId: number,
) =>
  useQuery({
    queryKey: ["additionalServices", "files", jointBillServiceId],
    queryFn: () =>
      downloadAdditionalServiceFiles(serviceProviderId, jointBillServiceId),
    enabled: false,
  });
